export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4">
                <i className="ri-smartphone-line"></i>
                APP下载
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">
                随时随地，吃瓜不缺席
              </h2>
              <p className="text-sm md:text-base text-background-50/80 mb-6 max-w-md">
                下载51吃瓜APP，开启推送通知，重大爆料第一时间送达。
                支持iOS和Android双平台，海量吃瓜内容随身看。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="w-full sm:w-auto px-6 py-3 bg-background-50 text-primary-600 font-semibold rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
                  <i className="ri-apple-line text-lg"></i>
                  App Store 下载
                </button>
                <button className="w-full sm:w-auto px-6 py-3 bg-background-950/20 text-background-50 font-medium rounded-full border border-background-50/30 hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </button>
              </div>
              <p className="text-xs text-background-50/50 mt-4">已累计下载超过500万次 · 评分4.8分</p>
            </div>

            <div className="flex-shrink-0">
              <div className="relative">
                <div className="absolute inset-0 bg-background-50/10 rounded-3xl blur-2xl"></div>
                <div className="relative w-56 h-80 bg-background-50 rounded-2xl overflow-hidden border-4 border-background-50 shadow-lg">
                  <div className="h-14 bg-primary-600 flex items-center justify-center">
                    <span className="font-heading text-background-50 text-sm">51吃瓜</span>
                  </div>
                  <div className="p-3 space-y-2">
                    <div className="h-2 bg-background-200 rounded w-3/4"></div>
                    <div className="h-2 bg-background-200 rounded w-full"></div>
                    <div className="h-2 bg-background-200 rounded w-5/6"></div>
                    <div className="h-16 bg-background-100 rounded-lg mt-3"></div>
                    <div className="h-2 bg-background-200 rounded w-2/3"></div>
                    <div className="h-2 bg-background-200 rounded w-full"></div>
                    <div className="h-16 bg-background-100 rounded-lg mt-2"></div>
                    <div className="h-2 bg-background-200 rounded w-1/2"></div>
                    <div className="h-2 bg-background-200 rounded w-4/5"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}